import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  Compass,
  Book,
  AlertTriangle,
  Info,
  MessageSquare
} from 'react-feather'

import { color, bp } from '../globalStyles'
import { Container } from './common'
import MenuItem from './MenuItem'
import Logo from './Logo'

const Footer = styled.footer`
  display: none;

  @media (${bp.desktop}) {
    display: block;
  }
`
const FooterTop = styled(Container)`
  border-top: 1px solid ${color.midGrey};
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${MenuItem} {
    width: 50%;
    font-size: 1.3rem;
  }
`

const FooterCol = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 33.33%;

  &:nth-child(2) {
    width: 66.66%;
  }
`
const LogoLink = styled(Link)`
  color: inherit;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 0 0;

  .Logo {
    width: 100%;
    max-width: 12.5rem;
    max-height: 3.5rem;
  }
`
const FooterBottom = styled.div`
  width: 100%;
  font-size: 1rem;
  padding-left: 3.75rem;
`
export default ({ glossary = [], infoPages, appVersion }) => (
  <Footer>
    <FooterTop>
      <FooterCol>
        <LogoLink to='/'>
          <Logo full />
        </LogoLink>
        {appVersion && <FooterBottom>Version {appVersion}</FooterBottom>}
      </FooterCol>
      <FooterCol>
        <MenuItem to='/more/your-location'>
          <Compass /> Your Location
        </MenuItem>
        <MenuItem to='/more/alerts'>
          <AlertTriangle /> Alerts & Notifications
        </MenuItem>
        {glossary.length > 0 && (
          <MenuItem to='/glossary'>
            <Book /> Glossary
          </MenuItem>
        )}
        {infoPages &&
          infoPages.map(infoPage => (
            <MenuItem
              key={`MoreItem-${infoPage.fields.slug}`}
              to={`/${infoPage.fields.slug}`}
            >
              <Info /> {infoPage.fields.title}
            </MenuItem>
          ))}
        <MenuItem to='/more/leave-feedback'>
          <MessageSquare /> Leave Feedback
        </MenuItem>
      </FooterCol>
    </FooterTop>
  </Footer>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js